export const STEPS = {
  DOCTOR: 'DOCTOR',
  PATIENT: 'PATIENT',
  ADD_PATIENT: 'ADD_PATIENT',
  ADD_PATIENT_DETAIL: 'ADD_PATIENT_DETAIL',
  SLOTS: 'SLOTS',
  INFO: 'INFO',
  OFFICE: 'OFFICE'
};

export const BOOK_TYPE = {
  PATIENT_BOOK: 'PATIENT_BOOK',
  DOCTOR_BOOK: 'DOCTOR_BOOK',
  CLINIC_BOOK: 'CLINIC_BOOK',
  REBOOK: 'REBOOK',
  RESCHEDULE: 'RESCHEDULE'
};
